export default __webpack_public_path__ + "static/preview-58ea2e5949a1eaf7d14cf261e3b3ef39.jpg";